import { useIdleTimer } from "react-idle-timer";

export const IdleTimeOut = () => {
  const onPrompt = () => {
    // Fire a Modal Prompt
  };
  const onIdle = () => {
    localStorage.clear();
    window.location.href = "/auth/login";
    // Close Modal Prompt
    // Do some idle action like log out your user
  };

  const onActive = (event: any) => {
    // Close Modal Prompt
    // Do some active action
  };

  const onAction = (event: any) => {
    // alert("HERE");
    // Do something when a user triggers a watched event
  };
  const {
    start,
    reset,
    activate,
    pause,
    resume,
    isIdle,
    isPrompted,
    isLeader,
    getTabId,
    getRemainingTime,
    getElapsedTime,
    getLastIdleTime,
    getLastActiveTime,
    getTotalIdleTime,
    getTotalActiveTime,
  } = useIdleTimer({
    onPrompt,
    onIdle,
    onActive,
    onAction,
    // timeout: 1000 * 60 * 20, == 20mint
    // timeout: 1000 * 10 * 1, // 10 sec
    timeout: 15 * 60000, // 15 * 1mint == 15 mint
    promptTimeout: 0,
    events: [
      "mousemove",
      "keydown",
      "wheel",
      "DOMMouseScroll",
      "mousewheel",
      "mousedown",
      "touchstart",
      "touchmove",
      "MSPointerDown",
      "MSPointerMove",
      "visibilitychange",
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
    crossTab: false,
    name: "idle-timer",
    syncTimers: 0,
    leaderElection: false,
  });
};
